import auth from "../middleware/auth";
import isIndicai from "../middleware/isIndicai";

const RelatorioIndicacoes = () =>
  import("../components/Views/Indicai/RelatorioIndicacoes.vue");
const ImagemCompartilhar = () =>
  import("../components/Views/Indicai/ImagemCompartilhar.vue");
const Home = () => import("../components/Views/Home.vue");

const breadcrumb = [
  { name: "IntegradON", link: process.env.INTERNO_URL },
  { name: "Indicaí", link: "/indicai" }
];

const desconto = [
  {
    path: "/indicai",
    component: Home,
    children: [
      {
        path: "/indicai",
        component: RelatorioIndicacoes,
        name: "Minhas Indicações",
        meta: {
          middleware: [auth, isIndicai],
          breadcrumb
        }
      },
      {
        path: "/indicai/imagem",
        component: ImagemCompartilhar,
        name: "Imagem ",
        meta: {
          middleware: [auth, isIndicai],
          breadcrumb
        }
      }
    ]
  }
];

export default desconto;



// WEBPACK FOOTER //
// ./src/routes/indicai.js